import { render, staticRenderFns } from "./SourceSimilarityHeatmap.vue?vue&type=template&id=3642a2fc&scoped=true&"
import script from "./SourceSimilarityHeatmap.vue?vue&type=script&lang=js&"
export * from "./SourceSimilarityHeatmap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3642a2fc",
  null
  
)

export default component.exports